import { CircularProgress, TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { debounce } from 'lodash';
import { useEffect, useCallback, useState } from 'react';
import { DEBOUNCE_DELAY_MS } from '../../../constants';

import { getAllCoaches } from '../../../services/apiService';
import { getFullName } from '../../../utils';

const CoachSelection = ({ coach, setCoach, label, courseType = '' }) => {
  const [coaches, setCoaches] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const [courseTypeMap, setCourseTypeMap] = useState(null);

  const changeHandler = async (searchText, mCourseType) => {
    const queryParams =
      label === 'Champion' || label === 'Communication Coach'
        ? { searchText, role: 'evaluator' }
        : { searchText };

    const response = await getAllCoaches(queryParams);
    setCoaches(response.map((item) => item.User));

    const mCourseTypeMap = new Map();
    response.map((item) => mCourseTypeMap.set(item.userId, item.courseType));
    setCourseTypeMap(mCourseTypeMap);

    setIsLoading(false);
  };

  const debounceSearch = useCallback(
    debounce(changeHandler, DEBOUNCE_DELAY_MS),
    []
  );

  useEffect(() => {
    if (inputValue && !coach) {
      setIsLoading(true);
      debounceSearch(inputValue, courseType);
    } else {
      setCoaches([]);
      setIsLoading(false);
    }
  }, [inputValue, courseType]);

  return (
    <div className='mt-8 max-w-2xl'>
      <Autocomplete
        autoHighlight
        options={coaches}
        getOptionLabel={(option) => `${getFullName(option)} (${option.email})`}
        getOptionSelected={(option, value) => option.id === value?.id}
        renderOption={(coach) => (
          <>
            <span>{getFullName(coach)}</span>
            <span className='text-sm ml-2 mr-2'>{coach.email}</span>
            {courseTypeMap?.get(coach.id) === 'data-science' && (
              <span className='text-gray-500 text-sm'>(DS)</span>
            )}
            {courseTypeMap?.get(coach.id) === 'web3' && (
              <span className='text-gray-500 text-sm'>(WD)</span>
            )}
          </>
        )}
        value={coach}
        onChange={(_, value) => setCoach(value)}
        inputValue={inputValue}
        onInputChange={(_, value) => setInputValue(value)}
        loading={isLoading}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant='outlined'
            placeholder={`Search for ${label}`}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {isLoading && <CircularProgress color='inherit' size={20} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </div>
  );
};

export default CoachSelection;
